import { env } from '@/lib/env';

export function redirectToLogin(urlToReturn?: string) {
  const currentUrl = window.location.href;
  window.location.replace(`${env('NAVER_LOGIN')}?mode=form&url=${encodeURIComponent(urlToReturn || currentUrl)}`);
}

export function redirectToNaverLogin(urlToReturn?: string) {
  const currentUrl = window.location.href;
  const targetUrl = urlToReturn || currentUrl;

  window.location.assign(`https://nid.naver.com/nidlogin.login?svctype=262144&url=${encodeURIComponent(targetUrl)}`);
}
